import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Router, NavigationEnd } from "@angular/router";

declare global {
  interface Window { analytics: any; }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(translate: TranslateService, private router: Router, private route: ActivatedRoute  ) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit() {
    this.router.events.subscribe((val: NavigationEnd) => {
      if (val instanceof NavigationEnd) {
        let comp: string = "Self-Signup " + this.findCompName(this.route);
        if(comp != null) window.analytics.page("page",comp,{path: val.url});
      }
    });
  }

  findCompName(node: ActivatedRoute): string {
    if (!node.firstChild) {
      let t = node.component.toString();
      return t.substring("function ".length, t.indexOf("Component"));
    } else {
      return this.findCompName(node.firstChild);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts